var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164 56H144V11.676C144 7.436 140.42 4 136 4C131.58 4 128 7.436 128 11.676V56H64V11.676C64 7.436 60.42 4 55.996 4C51.576 4 48 7.436 48 11.676V56H28C25.788 56 24 59.476 24 61.596V80.8C24 103.836 64 130.584 64 167.584V180H80V196H112V180H128V167.584C128 130.584 168 103.832 168 80.8V61.596C168 59.476 166.212 56 164 56ZM91.628 121.552C91.888 120.712 91.36 120 90.444 120H74.904C73.984 120 73.724 119.48 74.308 118.804C74.308 118.804 106.328 78.168 106.952 77.384C107.424 76.64 107.944 76.9 107.78 77.756C107.532 78.84 100.696 106.564 100.696 106.564C100.364 107.38 100.844 108 101.752 108H117.3C118.216 108 118.508 108.616 117.948 109.312C117.948 109.312 85.88 150.92 85.304 151.616C84.724 152.312 84.188 152.1 84.48 150.916L91.628 121.552Z",
    fill: "url(#paint0_linear_249_260)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_249_260",
    x1: 96,
    y1: 4,
    x2: 96,
    y2: 196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F48433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C65707"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.e46775a648ae94936b09a44af40f4079.svg";
export { ForwardRef as ReactComponent };